import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

const DELETE_USER_MUTATION = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
`

export default DELETE_USER_MUTATION
